<mat-toolbar class="ori-elevation-z4 header">
  <h3 oPlayId pidValue="news-modal-title">{{ "news" | translate }}</h3>
  <mat-icon
    mat-dialog-close
    color="primary"
    class="icon icon-close"
    svgIcon="close"
    role="button"
    title="close button"
    oPlayId
    pidValue="news-close-btn" />
</mat-toolbar>
<div mat-dialog-content class="modal-content">
  <mat-tab-group dynamicHeight [selectedIndex]="selectedTab | async">
    <mat-tab [label]="'news.application' | translate">
      <o-news-list [newsList]="applicationNews | async" [emptyLabel]="'news.application.empty'" />
    </mat-tab>
    @if (publicationNews | async) {
      <mat-tab [label]="'news.publication' | translate">
        <o-news-list [newsList]="publicationNews | async" [emptyLabel]="'news.publication.empty'" />
      </mat-tab>
    }
  </mat-tab-group>
</div>
